/***
 * 创建人：段锐
 * 时间：2019-06-10
 * 描述：对网址进行验证
 * 更新记录: 
 */
import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[validatorWww]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ValidatorWwwDirective,
      multi: true
    }
  ]
})
export class ValidatorWwwDirective implements Validator{
    constructor(){
        
    }
    validate(control: AbstractControl): { [key: string]: any } {
      let reg=/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;//正则表达式
      let url=control.value;//取得输入框的值

      if(!url || url==""){ //为空时不验证
        return null
      }
      if(reg.test(url)){
        return null;
      }
        return {
          ValidateUri:"网址格式不匹配"
        };
      }
}

